import { money } from "../utils";

const AtRiskRevenueCard = ({ value }) => {
  return (
    <div className="card">
      <div className="opacity-70">At-Risk Revenue</div>
      <div className="text-xs opacity-60 mt-1">
        Revenue likely to be lost next 30 days if no action is taken.
      </div>
      <div className="text-xl font-bold mt-1">{money(value)}</div>
    </div>
  );
};

export default AtRiskRevenueCard;
